export default __webpack_public_path__ + "static/001-c2c5244db7f7bdc8bcb6e9d1d0a7fb20.png";